<template>
  <div>
    <v-row align="center" style="margin: 20px">
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>جنسیت</span>
        <v-select
          :items="jensiatItems"
          item-text="text"
          item-value="value"
          v-model="jens"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>مقطع</span>
        <v-select
          :items="maqtaItems"
          item-text="text"
          item-value="value"
          v-model="maqta"
        ></v-select>
      </v-col>
    </v-row>
    <div>
      <div v-if="isMobile">
        <app-ayinNameh
          v-for="index in filteredAyins.length"
          :key="index"
          :index="index - 1"
          :ayinNameh="filteredAyins[index - 1]"
          :selectedIndex="selectedIndex"
          @clicked="onClickAyin"
          @downloadClicked="onClickDownload"
        >
        </app-ayinNameh>
      </div>
      <div v-else>
        <v-data-table
          :items="filteredAyins"
          :headers="ayinHeaders"
          item-key="serial"
          class="elevation-1 rounded"
          single-expand
          :no-data-text="tableText"
          :item-class="rowClass"
          :footer-props="{
            itemsPerPageAllText: 'همه',
            itemsPerPageText: 'تعداد ردیف',
          }"
          ><template v-slot:[`item.view`]="{ item }">
            <v-btn
              class="grid"
              color="green white--text"
              rounded
              @click="goToRoute(`${detailRoute}${item.serial}`)"
            >
              {{ "مشاهده" }}
            </v-btn>
          </template>
          <template v-slot:[`item.download`]="{ item }">
            <div v-if="item.fileSerial">
              <a @click="callDownload(`${item.serial}`)">
                {{ "دانلود" }}
              </a>
            </div>
          </template>
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
            از {{ pageStart }} تا {{ pageStop }}
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllAyinNamehCategories, downloadAttach } from "@/api/aboutus";
import { saveByteArray } from "@/utils/constants";
import AyinNamehApp from "./AyinNamehApp";

export default {
  components: {
    appAyinNameh: AyinNamehApp,
  },
  data() {
    return {
      detailRoute: "/aboutus/ayindetail/",
      jensiatItems: [
        { value: "-1", text: "همه موارد" },
        { value: "1", text: "برادران" },
        { value: "2", text: "خواهران" },
      ],
      maqtaItems: [
        { value: "-1", text: "همه موارد" },
        { value: "1", text: "عمومی" },
        { value: "2", text: "تخصصی" },
        { value: "3", text: "عالی" },
      ],
      jens: "-1",
      maqta: "-1",
      ayinHeaders: [
        {
          text: "عنوان",
          value: "name",
          width: "55%",
        },
        {
          text: "مقطع",
          value: "maqtaString",
          width: "10%",
        },
        {
          text: "جنسیت",
          value: "jensiatString",
          width: "10%",
        },
        {
          text: "وضعیت",
          value: "active",
          width: "10%",
        },
        {
          text: "دانلود",
          value: "download",
          width: "10%",
          sortable: false,
        },
        {
          text: "مشاهده",
          value: "view",
          width: "10%",
          sortable: false,
        },
      ],
      showModal: false,
      scrollY: 0,
      selectedIndex: -1,
      showDetails: false,
      ayins: [],
    };
  },
  computed: {
    filteredAyins() {
      let filteredAyins = [];
      if (Array.isArray(this.ayins) && this.ayins.length > 0) {
        filteredAyins = this.ayins.filter((ayin) => {
          if (this.jens === "-1" && this.maqta === "-1") {
            return true;
          } else if (this.jens === "-1") {
            return ayin.maqta === this.maqta;
          } else if (this.maqta === "-1") {
            return ayin.jensiat === this.jens;
          } else {
            return ayin.jensiat === this.jens && ayin.maqta === this.maqta;
          }
        });
      }
      return filteredAyins;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  created() {
    this.getAllAyinNamehs();
  },
  methods: {
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
    hideModal() {
      this.showModal = false;
    },
    callDownload(serial) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(serial)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    getAllAyinNamehs() {
      this.$store.commit("SET_TABLE_TEXT", true);
      getAllAyinNamehCategories()
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_TABLE_TEXT", false);
          if (data) {
            this.ayins = data;
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    rowClass(item) {
      let rowClass = item.description === "" ? "no-expand" : "";
      return rowClass;
    },
    onClickAyin(index) {
      this.goToRoute(`${this.detailRoute}${index}`);
    },
    onClickDownload(index) {
      this.callDownload(`${index}`);
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
</style>
